(function (window, $, paypal, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Checkout = window.JVZoo.Checkout || {};
    window.JVZoo.Checkout.PaypalCommercePlatform = window.JVZoo.Checkout.PaypalCommercePlatform || {};
    const MISSING_ORDER_KEY = "Response does not contain an Order Key";
    const MISSING_BILLING_AGREEMENT_KEY = "Response does not contain a Billing Agreement Key";
    /** PAYPAL_BILLING_AGREEMENT_PREKEY_FIELD_NAME must match \Paypal::const PAYPAL_BILLING_AGREEMENT_PREKEY_FIELD_NAME*/
    const PAYPAL_BILLING_AGREEMENT_PREKEY_FIELD_NAME = 'pcp_ba_prekey';
    /** PAYKEY_FIELD_NAME must match \Paypal::PAYKEY_FIELD_NAME*/
    const PAYKEY_FIELD_NAME = 'paykey';
    /** PCP_ORDER_ID_FIELD_NAME must match \Paypal::PCP_ORDER_ID_FIELD_NAME */
    const PCP_ORDER_ID_FIELD_NAME = 'pcp_order_id';
    const ORDER_BUMP_PREAPPROVAL_BATCH_ID = 'orderBumpPreapprovalBatchId';
    const IS_ONE_CLICK_UPSELL_PURCHASE = 'isOneClickUpsellPurchase';
    const IS_FREE_TRIAL = 'isFreeTrial';
    /** PAYPAL_BILLING_AGREEMENT_APPROVAL_DATA_FIELD_NAME must match \Paypal::const PAYPAL_BILLING_AGREEMENT_APPROVAL_DATA_FIELD_NAME constant*/
    const PAYPAL_BILLING_AGREEMENT_APPROVAL_DATA_FIELD_NAME = 'pcp_approval_json';
    const ORDER_APPROVAL_CALLBACK_URI = '/paypal/PcpOrderApproved';
    const BILLING_AGREEMENT_APPROVAL_CALLBACK_URI = '/paypal/PcpBillingAgreementApproved';
    // this value must match application/views/checkout/components/paypal_commerce_platform.twig
    const PAYPAL_BUTTON_DIV_SELECTOR = '#paypal-button-container';
    const BILLING_AGREEMENT_PROCESSING = 'Creating PayPal Billing Agreement...';
    const BILLING_AGREEMENT_CREATED = 'PayPal Billing Agreement Created.';
    const BILLING_AGREEMENT_FAILURE = 'PayPal Billing Agreement Creation Failed.';
    const BILLING_AGREEMENT_APPROVED_MESSAGE = 'Your PayPal Billing Agreement Has Been Approved!';
    const FINALIZING_ORDER_MESSAGE = "Please wait while we finish processing your order.";
    const ORDER_PROCESSING = 'Creating PayPal Order...';
    const ORDER_CREATED = 'PayPal Order Created.';
    const ORDER_FAILURE = 'PayPal Order Creation Failed.';
    const ORDER_CAPTURED = 'Order Captured';
    const REQUEST_PROCESSING_MESSAGE_NAME = 'pcp_request_processing';
    const REQUEST_OUTCOME_MESSAGE_NAME = 'pcp_request_outcome';
    const ADDITIONAL_FORM_VALUES = {
        // This field name must be kept in sync with \\Paypal::PAYPAL_COMMERCE_PLATFORM_CHECKOUT_FLAG_FIELD_NAME
        pcp_checkout: true
    };
    var _orderData = null;
    var _billingAgreementData = null;

    const buildRemoveProcessingMessage = function (enableUserInteraction) {
        return function() {
            if (enableUserInteraction) {
                window.JVZoo.Checkout.EnableUserInteraction();
            }
            window.JVZoo.DisplayMessages.RemoveByName(REQUEST_PROCESSING_MESSAGE_NAME);
        }
    };

    const formatInvalidOrderFormExitStatusMessage = function (expectedStatus, receivedStatus) {
        return "Expected Order Form Exit Status: \"" + expectedStatus + "\" but received \"" + receivedStatus + "\"";
    };

    const removeMessages = function () {
        window.JVZoo.DisplayMessages.RemoveByName(REQUEST_PROCESSING_MESSAGE_NAME);
        window.JVZoo.DisplayMessages.RemoveByName(REQUEST_OUTCOME_MESSAGE_NAME);
    };

    const beginProcessing = function (message, disableUserInteraction) {
        removeMessages();
        if (disableUserInteraction) {
            window.JVZoo.Checkout.DisableUserInteraction();
        }
        window.JVZoo.DisplayMessages.Add('info', message, REQUEST_PROCESSING_MESSAGE_NAME);
    };

    const showProcessingSuccessfulMessage = function (message) {
        removeMessages();
        window.JVZoo.DisplayMessages.Add('info', message, REQUEST_OUTCOME_MESSAGE_NAME);
    };

    const showProcessingErrorMessage = function (message) {
        removeMessages();
        window.JVZoo.DisplayMessages.Add('error', message, REQUEST_OUTCOME_MESSAGE_NAME);
    };

    const buildOnProcessingErrorHandler = function (message) {
        return function (error) {
            var logMessage = "PayPal Order Creation Error:\n";
            window.JVZoo.RemoteLog.Alert(logMessage, {'PCP_ERROR': error});
            console.error(logMessage, "\nerror: ", error, "\nmessage: ", message);
            window.JVZoo.DisplayMessages.RemoveByName(REQUEST_PROCESSING_MESSAGE_NAME);
            window.JVZoo.DisplayMessages.Add('error', message, REQUEST_OUTCOME_MESSAGE_NAME);
            throw error;
        }
    };

    // region Order Processing
    const onCreateOrder = function (data, actions) {
        // no need to disable user interaction as PayPal's overlay does that already
        beginProcessing(ORDER_PROCESSING, false);
        _orderData = {payKey: null, orderId: null};
        var onCreateOrderResponseError = buildOnProcessingErrorHandler(ORDER_FAILURE);
        return window.JVZoo.Checkout.SubmitOrderFormAsPromise(ADDITIONAL_FORM_VALUES, false, false)
            .then(onCreateOrderResponse)
            .catch(onCreateOrderResponseError)
            .finally(buildRemoveProcessingMessage(true));
    };

    /**
     * This method is called in response to the POST request that is initiated in the onCreateOrder method.
     *
     * @param {{}} checkoutResponseStructure As defined in window.JVZoo.Checkout.SubmitOrderFormAsPromise
     * @return {string} PayPal Order Id
     */
    const onCreateOrderResponse = function (checkoutResponseStructure) {
        if (!checkoutResponseStructure
            || checkoutResponseStructure.orderFormExitStatus
                !== window.JVZoo.Checkout.OrderFormExitCodes.CREATE_TRANSACTION_SUCCESSFUL
        ) {
            throw new Error(
                formatInvalidOrderFormExitStatusMessage(
                    window.JVZoo.Checkout.OrderFormExitCodes.CREATE_TRANSACTION_SUCCESSFUL,
                    checkoutResponseStructure ? checkoutResponseStructure.order_form_exit_status : window.JVZoo.Checkout.Messages.ORDER_FAILED_MESSAGE
                )
            );
        }
        if (!checkoutResponseStructure.data
            || !checkoutResponseStructure.data.transaction
            || !checkoutResponseStructure.data.transaction.paypal_commerce_platform_order_key
            || !checkoutResponseStructure.data.transaction.paykey
        ) {
            throw new Error(MISSING_ORDER_KEY);
        }

        _orderData.orderId = checkoutResponseStructure.data.transaction.paypal_commerce_platform_order_key;
        _orderData.paykey = checkoutResponseStructure.data.transaction.paykey;
        showProcessingSuccessfulMessage(ORDER_CREATED);
        return _orderData.orderId;
    };

    /**
     * The onApprovedOrder method executes after the order is approved by the customer. It then
     * @param checkoutResponseStructure
     */
    const onExecuteOrderResponse = function (checkoutResponseStructure) {
        if (window.JVZoo.Debug) {
            console.debug(
                "onExecuteOrderResponse called!\nresponse: ",
                checkoutResponseStructure.response.statusText,
                "\ncheckoutResponseStructure: ",
                checkoutResponseStructure
            );
        }
        if (checkoutResponseStructure.error) {
            var logMessage = 'Network response was not ok!';
            window.JVZoo.RemoteLog.Alert(
                logMessage,
                {'CHECKOUT_RESPONSE_STRUCTURE': checkoutResponseStructure}
            );
            console.error(logMessage,  "\ncheckoutResponseStructure: ", checkoutResponseStructure);
            throw new Error('Network response was not ok: ' + checkoutResponseStructure.error);
        }
        if (checkoutResponseStructure.orderFormExitStatus
            !== window.JVZoo.Checkout.OrderFormExitCodes.CAPTURE_FUNDS_SUCCESSFUL
            || !checkoutResponseStructure.data
            || !checkoutResponseStructure.data.redirectUri
        ) {
            window.JVZoo.RemoteLog.Alert(
                "PCP Failed to capture funds!",
                {'CHECKOUT_RESPONSE_STRUCTURE': checkoutResponseStructure}
            );
            console.error("checkoutResponseStructure.orderFormExitStatus: ", checkoutResponseStructure.orderFormExitStatus);
            throw new Error('Failed to capture funds! '+ checkoutResponseStructure.orderFormExitStatus);
        }
        if (window.JVZoo.Debug) {
            console.debug("onExecuteOrderResponse Success: ", checkoutResponseStructure.orderFormExitStatus);
        }
        showProcessingSuccessfulMessage(ORDER_CAPTURED);
        // apply the response (ie... redirect)
        window.location = checkoutResponseStructure.data.redirectUri;
    };

    const onExecuteOrderError = function (error) {
        if (window.JVZoo.Debug) {
            console.debug("onExecuteOrderError called! Error: ", error);
        }
        window.JVZoo.RemoteLog.Alert("PCP ExecuteOrderError", {'PCP_ERROR': error});
        showProcessingErrorMessage(window.JVZoo.Checkout.Messages.ORDER_FAILED_MESSAGE);
    };

    /**
     * This method is called after the customer approves the payment in PayPal. It's primary function is to post the
     * approved order information back to our server so that the payment can be executed.
     * @param data
     * @param actions
     * @return {Promise<*>}
     */
    const onApproveOrder = function (data, actions) {
        if (window.JVZoo.Debug) {
            console.debug("onApproveOrder Called:\nData:", data, "\nActions:\n", actions );
        }
        // Submit approval to Server
        var formData = new FormData();
        // TODO: Request a New CSRF token if theirs has expired
        formData.append(window.JVZoo.Security.GetCsrfFieldName(), window.JVZoo.Security.GetCsrfHash());
        if (_orderData.paykey) {
            formData.append(PAYKEY_FIELD_NAME, _orderData.paykey);
        }
        if (_orderData.orderId) {
            formData.append(PCP_ORDER_ID_FIELD_NAME, _orderData.orderId);
        }
        beginProcessing(window.JVZoo.Checkout.Messages.PROCESSING_ORDER_MESSAGE, true);

        var checkoutResponseStructure = window.JVZoo.Checkout.NewCheckoutRepsonseStructure();
        return fetch(
            ORDER_APPROVAL_CALLBACK_URI,
            {
                method: 'POST',
                headers: {'Accept': 'application/json'},
                mode: 'same-origin',
                cache: 'no-cache',
                credentials: 'same-origin',
                redirect: 'error',
                referrerPolicy: "same-origin",
                body: formData,
            }
        )
            .then(window.JVZoo.Checkout.BuildDecodeCheckoutResponseHandler(checkoutResponseStructure))
            .then(window.JVZoo.Checkout.BuildProcessCheckoutResponseHandler(checkoutResponseStructure, false))
            .then(onExecuteOrderResponse)
            .catch(window.JVZoo.Checkout.BuildCheckoutResponseErrorHandler(checkoutResponseStructure, false))
            .catch(onExecuteOrderError)
            .finally(buildRemoveProcessingMessage(false));
    };
    // endregion Order Processing

    // region Billing Agreement Processing
    /**
     * Called as soon as one of the PayPal payment buttons is clicked
     * @param data
     * @param actions
     * @return {Promise<*>}
     */
    const onCreateBillingAgreement = function (data, actions) {
        // no need to disable user interaction as PayPal's overlay does that already
        beginProcessing(BILLING_AGREEMENT_PROCESSING, false);
        _billingAgreementData = {preKey: null};
        var onProcessingErrorHandler = buildOnProcessingErrorHandler(BILLING_AGREEMENT_FAILURE);
        return window.JVZoo.Checkout.SubmitOrderFormAsPromise(ADDITIONAL_FORM_VALUES, false, false)
            .then(onCreateBillingAgreementResponse)
            .catch(onProcessingErrorHandler)
            .finally(buildRemoveProcessingMessage(true));
    };

    /**
     * This function executes when the JVZoo server responds to the POST request that is initiated in
     * onCreateBillingAgreement
     *
     * @param {{}} checkoutResponseStructure As defined in window.JVZoo.Checkout.SubmitOrderFormAsPromise
     * @return {string} PayPal Billing Agreement Identifier
     */
    const onCreateBillingAgreementResponse = function (checkoutResponseStructure) {
        // this test should match \JVZoo\Constant\Checkout\OrderFormExitCodes::CREATE_TRANSACTION_SUCCESSFUL
        if (checkoutResponseStructure.orderFormExitStatus
            !== window.JVZoo.Checkout.OrderFormExitCodes.CREATE_RECURRING_SUCCESSFUL) {
            window.JVZoo.RemoteLog.Alert(
                "PCP Failed to create BillingAgreement",
                {'CHECKOUT_RESPONSE_STRUCTURE': checkoutResponseStructure}
            );
            throw new Error(
                formatInvalidOrderFormExitStatusMessage(
                    window.JVZoo.Checkout.OrderFormExitCodes.CREATE_RECURRING_SUCCESSFUL,
                    checkoutResponseStructure.order_form_exit_status
                )
            );
        }

        if (!checkoutResponseStructure.data.recurring.prekey) {
            window.JVZoo.RemoteLog.Alert(
                "PCP BillingAgreement is missing PreKey",
                {'CHECKOUT_RESPONSE_STRUCTURE': checkoutResponseStructure}
            );
            throw new Error(MISSING_BILLING_AGREEMENT_KEY);
        }

        _billingAgreementData.prekey = checkoutResponseStructure.data.recurring.prekey;
        _billingAgreementData.orderBumpPreapprovalBatchId = checkoutResponseStructure.data.orderBumpPreapprovalBatchId;
        _billingAgreementData.isOneClickUpsellPurchase = checkoutResponseStructure.data.isOneClickUpsellPurchase;
        _billingAgreementData.isFreeTrial = checkoutResponseStructure.data.isFreeTrial;

        showProcessingSuccessfulMessage(BILLING_AGREEMENT_CREATED);
        return _billingAgreementData.prekey;
    };

    /**
     * Called after onCreateBillingAgreementResponse returns control to PayPal.
     * PayPal then requires the user approve the billing agrement which, when completed, leads to billing agreement
     * approval.
     * @param data
     * @param actions
     * @return {Promise<*>|*}
     */
    const onApproveBillingAgreement = function (data, actions) {
        if (window.JVZoo.Debug) {
            console.debug("onApproveBillingAgreement Called!\nData:", data, "\nActions:\n", actions);
        }
        window.JVZoo.DisplayMessages.Add('success', BILLING_AGREEMENT_APPROVED_MESSAGE, REQUEST_PROCESSING_MESSAGE_NAME);
        // Submit approval to Server
        var formData = new FormData();
        // TODO: Request a New CSRF token if theirs has expired
        formData.append(window.JVZoo.Security.GetCsrfFieldName(), window.JVZoo.Security.GetCsrfHash());
        formData.append(PAYPAL_BILLING_AGREEMENT_PREKEY_FIELD_NAME, _billingAgreementData.prekey);
        formData.append(PAYPAL_BILLING_AGREEMENT_APPROVAL_DATA_FIELD_NAME, JSON.stringify(data));
        if (_billingAgreementData.orderBumpPreapprovalBatchId) {
            formData.append(ORDER_BUMP_PREAPPROVAL_BATCH_ID, _billingAgreementData.orderBumpPreapprovalBatchId);
        }
        if (_billingAgreementData.isOneClickUpsellPurchase) {
            formData.append(IS_ONE_CLICK_UPSELL_PURCHASE, _billingAgreementData.isOneClickUpsellPurchase);
        }
        if (_billingAgreementData.isFreeTrial) {
            formData.append(IS_FREE_TRIAL, _billingAgreementData.isFreeTrial);
        }
        beginProcessing(window.JVZoo.Checkout.Messages.PROCESSING_PRE_APPROVAL_MESSAGE, true);

        var checkoutResponseStructure = window.JVZoo.Checkout.NewCheckoutRepsonseStructure();

        return fetch(
            BILLING_AGREEMENT_APPROVAL_CALLBACK_URI,
            {
                method: 'POST',
                headers: {'Accept': 'application/json'},
                mode: 'same-origin',
                cache: 'no-cache',
                credentials: 'same-origin',
                redirect: 'error',
                referrerPolicy: "same-origin",
                body: formData,
            }
        )
            .then(window.JVZoo.Checkout.BuildDecodeCheckoutResponseHandler(checkoutResponseStructure))
            .then(function (x) {
                return x;
            })
            .then(window.JVZoo.Checkout.BuildProcessCheckoutResponseHandler(checkoutResponseStructure, true))
            .catch(window.JVZoo.Checkout.BuildCheckoutResponseErrorHandler(checkoutResponseStructure, false))
            .catch(onApproveBillingAgreementError)
            .finally(buildRemoveProcessingMessage(false));
    };

    const onApproveBillingAgreementError = function (error) {
        window.JVZoo.RemoteLog.Alert(
            "PCP ApproveBillingAgreementError",
            {'PCP_ERROR': error}
        );
        console.error("onApproveBillingAgreementError: ", error);
    };

    // endregion Billing Agreement Processing

    window.JVZoo.Checkout.PaypalCommercePlatform.applyBindings = function($rootElement) {
        var buttonSettings = null;
        if (window.JVZoo.Checkout.getIsRecurringProduct()) {
            buttonSettings = {
                createBillingAgreement: onCreateBillingAgreement,
                onApprove: onApproveBillingAgreement,
                onError: function (err) {
                    console.debug(err);
                }
            };
        } else {
            buttonSettings = {
                createOrder: onCreateOrder,
                onApprove: onApproveOrder,
                onError: function (err) {
                    console.debug(err);
                }
            };
        }
        paypal.Buttons(buttonSettings).render(PAYPAL_BUTTON_DIV_SELECTOR);
    };

    $(document).ready(function () {
        window.JVZoo.Checkout.PaypalCommercePlatform.applyBindings($(document));
    });

})(window, jQuery, paypal);